// @ts-nocheck
/* eslint-disable */
export const chevronDownIcon = {
    data: `<svg viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 1.5L8.5 9L1 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'chevron-down' as const
};